//12-nov-2018 Priyan R
import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as appActions from '../actions/appactions'
export default function ShowTopMessage() {
    const state = useSelector(state => state.appReducer);
    let topMessages = state.topMessages;
    const dispatch = useDispatch();
    const closeMessage = (message) => {
        dispatch(appActions.removeTopMessage(message));
    }
    if (topMessages.length == 0)
        return null;
    return (
        <>

            <div style={{
                position: "fixed",
                maxWidth: "35%",
                top: 5,
                right: "1%",
                zIndex: 10000000000
            }}>
                <div
                >
                    {topMessages.map((topMessage, index) => (
                        <div key={index}
                            style={
                                topMessage.messageOptions.messageType == "success" ?
                                    { color: '#fff', backgroundColor: '#00A300', borderRadius: "15px", border: "1px solid #00A300",minWidth: '200px',padding: "10px 10px 10px 10px", paddingTop: "5px", position: "relative" }
                                    : topMessage.messageOptions.messageType == "warning" ?
                                        { color: '#000', backgroundColor: '#edbe4d', borderRadius: "15px", border: "1px solid #edbe4d", padding: "10px 10px 10px 10px", paddingTop: "5px", position: "relative" }
                                        : topMessage.messageOptions.messageType == "danger" ?
                                            { color: '#fff', backgroundColor: '#d94d4d', borderRadius: "15px", border: "1px solid #d94d4d", padding: "10px 10px 10px 10px", paddingTop: "5px", position: "relative" }
                                            :
                                            { color: '#fff', backgroundColor: '#536de6', borderRadius: "15px", border: "1px solid #536de6", padding: "10px 10px 10px 10px", paddingTop: "5px", position: "relative" }
                            }>
                            <strong>
                                {topMessage.messageOptions.messageType == "success" ? <i className="mdi mdi-check-circle"></i>
                                    :
                                    topMessage.messageOptions.messageType == "warning" ? <i className="dripicons-warning"></i>
                                        :
                                        topMessage.messageOptions.messageType == "danger" ? <i className="dripicons-wrong"></i>
                                            :
                                            <i className="dripicons-information"></i>
                                }
                                <b> {
                                    topMessage.messageOptions.messageType == "success" ? "Success"
                                        :
                                        topMessage.messageOptions.messageType == "warning" ? "Warning"
                                            :
                                            topMessage.messageOptions.messageType == "danger" ? "Error"
                                                : "Information"

                                }</b>
                                <a href="#" style={{
                                    color:
                                        topMessage.messageOptions.messageType == "success" ? "#fff" :
                                            topMessage.messageOptions.messageType == "warning" ? "#000" :
                                                topMessage.messageOptions.messageType == "danger" ? "#fff" : "#fff"
                                }} className="float-end" onClick={(e) => {
                                    e.preventDefault();
                                    closeMessage(topMessage)
                                }}>X</a></strong>
                            <br></br>{topMessage.messageText}
                        </div>


                    ))}
                </div>
            </div>

        </>
    )
}

